import {
  default as LoadingContainer,
  LoadingBall,
  LoadingProps,
} from "@ingka/loading";

export type { LoadingProps } from "@ingka/loading";

export const Loading = ({ text = "Loading...", ...props }: LoadingProps) => (
  <LoadingContainer labelTransitions={true} text={text} {...props}>
    <LoadingBall />
  </LoadingContainer>
);
